/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { Button, InputGroup, FormControl, Form, Row, Col, Carousel } from 'react-bootstrap';

import { Footer } from 'features/components/base/layouts';
import {
    doorTwoImage,
    homeBanner,
    homeSofa,
    bgTransparantBlack,
    sellOne,
    sellTwo,
    sellWith,
    howItWorks, whoWeAre,
    doorThreeImage, doorOneImage,
    bottomEarthImage,
    bottomSofaImage, poweredByImage, noSale, sellWithUsBan,uniquefeatureImage,caringtransitionslogo,youmakediffrence,
    franchise,
    premiermemberAd
} from 'shared/images/images';
import moment from 'moment';
import store from 'features/store';
import { isAuthorized } from 'shared/settings/auth';
import { DoorView } from 'shared/door-view/DoorView';
import { SaleCardViewDataTable } from 'shared/sale-card-view-datatable/SaleCardViewDataTable';

import { SalesService } from 'shared/services';
import { ADSENSE, APP_STORE_URL, PLAY_STORE_URL, SellWithUsLink } from 'shared/settings/config';
import Validators from 'shared/validators';
import { getMaintainData, homeState, previousState } from 'shared/settings/stateMaintain';
import Helmet from 'react-helmet';

import './Home.scss';
import { addDataLayer, bannerImage, pmAutoNavigateToNextScreen} from 'shared/utils/utils';
import { Adsense } from 'shared/utils/Adsense';

/**

first page to render when user logs in

@Author Karthik

@param

@return home html

**/

class Home extends Component {

    constructor(props) {
        super(props);
        this.expiration = moment().add(13, 'days');
        this.homeRef = createRef();
        this.state = {
            duration: moment().add(13, 'days'),
            contentHeight: 0,
            loading: true,
            innerWidth: window.innerWidth,
            todayDeal: null,
            endingSoon: [],
            popular: {
                "sort": [{ "field": "bidcount", "direction": "desc" }],
                "page": { "size": 3 },
                "filter": [
                    { "field": "salestatus", "value": "Started", "op": "=", "join": "AND" },
                    { "field": "itemstatus", "value": "Ready", "op": "=", "join": "AND" },
                    { "field": "itemtypeid", "value": 3, "op": "<", "join": "AND" }
                ]
            },
            unique: {
                /*  "sort": [{ "field": "buynowprice", "direction": "desc" }], */
                "filter": [
                    { "field": "salestatus", "value": "Started", "op": "=", "join": "AND" },
                    /* { "field": "buynowprice", "value": null, "op": "IS NOT", "join": "AND" }, */
                    { "field": "itemstatus", "value": "Ready", "op": "=", "join": "AND" },
                    { "field": "coolandunique", "value": 1, "op": "=", "join": "AND" },
                    { "field": "isfeatured", "value": 1, "op": "=", "join": "AND" }
                ],
                "page": { "size": 3 }
            },
            viewMoreItems: { mostPopular: null, coolAndUnique: null },
            searchValue: { value: '' },
            zipcode: '',
            estateSaleForm: {
                zipcode: { value: '', error: '', validators: [Validators.equalToLength(5)] },
                miles: { value: '25', error: '', validators: [Validators.required()] },
            },
            errorMessage: '',
            estateSaleForm1: {
                zipcode: { value: '', error: '', validators: [Validators.equalToLength(5)] },
                miles: { value: '25', error: '', validators: [Validators.required()] },
            },
            errorMessage1: '',
            formValid: false,
            activeIndex: 0,
            refreshScreen: false,
            scrollTo: 0,
            featureSaleLoading: true,
            advListLoading: true,
        };
        this.try48Hour = false;
    }

    componentDidMount() {
        setInterval(() => {
            this.countdown();
        }, 1000);
        store.dispatch({ type: 'TOGGLE_SEARCH_BOX', payload: false });
        store.dispatch({ type: 'SET_PREVIOUS_PATH', payload: { component: "Home" } });
        window.addEventListener('resize', this.setHeight);
        this.imagesLoaded();
        this.advListCall();
        let value = this.props.location.search.split('&')
        let google_value = value[0]?.split('=')[1];
        let campaign_value = value[2]?.split('=')[1];
        store.dispatch({type: 'SET_GOOGLE_ADS_USER', payload: {user_type: google_value, campaign_type: campaign_value}})
    }

    componentDidUpdate() {
        window.addEventListener('resize', this.setHeight);
    }

    loadImage = (image) => {
        return new Promise((resolve, reject) => {
            const loadImg = new Image();
            loadImg.src = image;
            loadImg.onload = () => {
                resolve(image)
            };

            loadImg.onerror = err => reject(err);
        })
    }
    imagesLoaded = () => {
        const IMAGES = [
            doorTwoImage,
            homeBanner,
            homeSofa,
            bgTransparantBlack,
            sellOne,
            sellTwo,
            sellWith,
            howItWorks, whoWeAre,
            doorThreeImage, doorOneImage,
            bottomEarthImage,
            bottomSofaImage, poweredByImage
        ]
        Promise.all(IMAGES.map(image => this.loadImage(image)))
            .then(() => {
                this.setState({
                    loading: false
                }, () => {
                    this.getRequiredData();
                });
            })
            .catch(err => console.log("Failed to load images", err));
    }
    countdown = () => {
        const now = moment();
        const expiration = this.expiration;

        // get the difference between the moments
        const diff = expiration.diff(now);

        //express as a duration
        const diffDuration = moment.duration(diff);
        this.setState({
            duration: diffDuration
        });
    }
    joinPremier = (props) => {
        if (props.user.suspensionstatus == "ALL") {
            store.dispatch({ type: 'TOGGLE_SUSPEND_MODAL', payload: true });
        }
        else {
            if (props.user.id) {
                pmAutoNavigateToNextScreen(props, props.user, null, null, null, false, true);
            } else {
                store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: 'Sign-In', fromBannerBtn: true } });
            }
            let dataLayerData = {
                'event': 'premier_banner_clicks',
            }
            addDataLayer(dataLayerData);
        }
    }

    setHeight = () => {
        const content = document.getElementsByClassName('sale-content');
        const contentHeight = content.length > 0 ? content[0].clientHeight + 98 : 0;
        this.setState({
            contentHeight: contentHeight,
            innerWidth: window.innerWidth
        })
    }

    navigate = (sale) => {
        this.props.history.push(`/estate-sale/${sale.id}`);
    }

    signInOpen = (flag) => {
        if (!flag) {
            store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: 'Sign-In' } });
        } else {
            this.props.history.push(`/my-account/my-info/personal-info`);
        }
    }

    getRequiredData = () => {
        const previous = getMaintainData(previousState);
        if (previous && previous.apply) {
            this.getPreviousValues();
        } else {
            this.getSalesList();
        }
    }

    getSalesList = () => {
        this.getTodayDealSales();
        const endingSoonData = {
            "sort": [{ "field": "endtimeutc", "direction": "asc" }],
            "field": ["id", "title", "city", "state", "zipcode", "starttime", "endtime", "itemcount", "status", "provenance", "timezoneid", "timezonename", "endtimeutc"],
            "filter": [{ "field": "itemcount", "value": 1, "op": ">=", "join": "AND" },
            { "field": "status", "value": "Started", "op": "=", "join": "AND" },
            { "field": "isdeleted", "value": 0, "op": "=", "join": "AND" }],
            "page": { 'size': 3 }
        };
        SalesService.getSalesList(endingSoonData).then(
            endingSoon => {
                let temp = [];
                temp = endingSoon.data.data;
                if ( temp.length > 0 ) {
                    const imageListData = { "filter": [{ "field": "saleid", "value": [temp.map(elem => { return elem.id; })], "op": "IN", "join": "AND" }] };
                    SalesService.getSaleImagesList(imageListData).then(
                        saleImageList => {
                            temp.forEach((elem) => {
                                let imageData = saleImageList.data.data.find((image) => {  return image.saleid == elem.id; })
                                if (typeof imageData != "undefined") {
                                    let imageUrlData = imageData.saleimageurl || imageData.locationimageurl;
                                    if ( typeof imageUrlData === 'string' ) {
                                        elem.saleimageurl = imageUrlData.split(',').find(img => { return img.includes('profile#*#'); })?.split("#*#")[1];
                                    }
                                }
                            })
                            this.setState({
                                endingSoon: endingSoon.data.data
                            }, () => {
                                store.dispatch({ type: 'HOME_LOADED', payload: true });
                                this.setHeight();
                                this.setState({
                                    loading: false
                                });
                            });
                        }        
                    ).catch((error) => {
                        // TODO: Error message handle
                    });
                } else {
                    this.setState({
                        endingSoon: endingSoon.data.data
                    }, () => {
                        store.dispatch({ type: 'HOME_LOADED', payload: true });
                        this.setHeight();
                        this.setState({
                            loading: false
                        });
                    });
                }
            }
        ).catch((error) => {
            // TODO: Error message handle
        });
    }

    advListCall =  () => {
        const data = {
            "filter": [
                { "field": "status", "value": "Active", "op": "=", "join": "AND" },
                { "field": "advertisetype", "value": "AD", "op": "=", "join": "AND" }
            ]
        };
        SalesService.getAdvList(data).then( response => {
                this.setState({
                    advList: response.data.data,
                    advListLoading: false
                })
            }).catch((error) => {
                this.setState({
                    advListLoading: false
                });
            });
    }

    moveToUrl(url, title) {
        this.props.history.push(url)
        let dataLayerData = {
            'event': 'advertise_clicks',
            'title': title
        }
        addDataLayer(dataLayerData);
    }

    getTodayDealSales = () =>  {           
        const now = moment.utc();
        const end = this.try48Hour ? now.add(48, 'hours').format("YYYY-MM-DD HH:mm:ss") : now.add(24, 'hours').format("YYYY-MM-DD HH:mm:ss");

        //   const start = now.startOf('day').format('YYYY-MM-DD hh:mm:ss');
        // const end = now.endOf('day').format('YYYY-MM-DD hh:mm:ss');
        //  const end = this.try48Hour ? moment().add(48, 'hours').format('YYYY-MM-DD HH:mm:ss') : moment().add(24, 'hours').format('YYYY-MM-DD HH:mm:ss');
        const todayDealData = {
            "page": { "size": 10 },
            "sort": [{ "field": "endtimeutc", "direction": "asc" }],
            "field": ["id", "title", "city", "state", "zipcode", "starttime", "endtime", "itemcount", "status", "provenance", "timezoneid", "timezonename", "endtimeutc"],
            "filter": [
                { "field": "isfeatured", "value": 1, "op": "=", "join": "AND" },
                { "field": "status", "value": "Started", "op": "=", "join": "AND" },
                { "field": "endtimeutc", "value": end, "op": "<=", "join": "AND" },
                { "field": "isdeleted", "value": 0, "op": "=", "join": "AND" }
            ]
        };
        SalesService.getSalesList(todayDealData).then(
            todayDeal => {
                const todayData = todayDeal.data.data;
                if (todayData.length === 0 && !this.try48Hour) {
                    this.try48Hour = true;
                    this.getTodayDealSales();
                } else {
                    const todayDataCheck = todayData.length > 0 ? todayData : null;
                    if (todayDataCheck) {
                        this.getTodayDealData(todayDataCheck);
                    } else {
                        this.setState({
                            featureSaleLoading: false
                        });
                    }
                }
            }
        ).catch((error) => {
            // TODO: Error message handle
            this.setState({
                featureSaleLoading: false
            });
        });            
    }

    getTodayDealData = async (todayData) => {
        const temp = todayData.map(x => x.id);
        const todayDataAll = [...new Set(temp)];
        const imageListData = { "filter": [{ "field": "saleid", "value": [todayDataAll], "op": "IN", "join": "AND" }] };

        SalesService.getSaleImagesList(imageListData).then(
            saleImageList => {
                const imageList = saleImageList.data.data;
                const tempSale = todayData;
                imageList.forEach(image => {
                    const index = tempSale.findIndex(x => x.id === image.saleid);
                    if (index !== -1) {
                        let imageUrlData = image.saleimageurl || image.locationimageurl;
                        if ( typeof imageUrlData === 'string' ) {
                            tempSale[index]['saleimageurl'] = imageUrlData.split(',').find(img => { return img.includes('profile#*#'); })?.split("#*#")[1];
                        }
                    }                    
                });
                this.setState({
                    todayDeal: tempSale,
                    loading: false,
                    featureSaleLoading: false
                });
            }
        ).catch((error) => {
            // TODO: Error message handle
            this.setState({
                featureSaleLoading: false
            });
        });

    }

    getPreviousValues = () => {
        const temp = getMaintainData(homeState);
        this.setState({
            ...this.state,
            ...temp,
            loading: false,
        }, () => {
            this.scrollToPrevious();
        });
    }

    scrollToTop = () => {
        this.homeRef.current.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }

    estateSaleList = () => {
        this.props.history.push('/estate-sale/list');
    }

    openCaringTransitions = () => {
        window.open('https://www.caringtransitions.com/', '_blank');
    }

    sellWithUs = () => {
        window.open(SellWithUsLink, '_blank');
        let dataLayerData = {
            'event': 'sell_with_us'
        }
        addDataLayer(dataLayerData); 
    }
    viewMoreItems = (flag, zipcode) => {
        let paramsData = {
            data: {"category" :"All Categories", "location" : "All", "sortBy" :  "itemclosetime#*#asc#*#Listing Ending First", "zipcode" :  zipcode },
            filter: { filter: [
                { "field": "zipcode", "value": zipcode, "op": "=", "join": "AND" },
                { "field": "miles", "value": "100", "op": "=", "join": "AND" },
                { "field": "salestatus", "value": "Started", "op": "=", "join": "AND" },
                { "field": "itemstatus", "value": "Ready", "op": "=", "join": "AND" },
            ]},
            sort: [{ "field": "itemclosetime", "direction": "asc" }],
            // field: ["zipcode"]
        }

        if(flag){
            this.props.history.push({ pathname:`/view-more-items/${flag}`, state: zipcode});
        }else if(zipcode){
            this.props.history.push(`/advance-search/items`, {advancedSearchFilter: paramsData, fromScreen: 'home' });
        }
        
    }

    getItemsList = (event, flag) => {
        if (flag === 'most-popular') {
            this.setState({
                viewMoreItems: {
                    ...this.state.viewMoreItems,
                    mostPopular: event,
                }
            });
        } else {
            this.setState({
                viewMoreItems: {
                    ...this.state.viewMoreItems,
                    coolAndUnique: event,
                }
            }, () => {
                if (event.scrollPage) {
                    this.scrollToPrevious();
                }
            });
        }
    }

    inputValueChange = (event) => {
        if (event.target.name === 'zipcode') {
            const value = event.target.value;
            event.target.value = value.replace(/[^0-9]/g, '');
            this.setState({
                zipcode: event.target.value,
                searchValue: {
                    ...this.state.searchValue,
                    value: ''
                }
            })
        }
        if(event.target.name === 'itemserach'){
            this.setState({
                zipcode: '',
                searchValue: {
                    ...this.state.searchValue,
                    value: event.target.value
                }
            })
        }
    }
    onSearchItems = (value) => {
        if(value === 'itemvalue' && this.state.searchValue.value){
            this.viewMoreItems(this.state.searchValue.value,  '' )

        }
        if(value === 'zipcode' && this.state.zipcode){
            
            this.viewMoreItems('',   this.state.zipcode  )
        }
        
    }
    joinToday = () => {
        if(this.props.user.membershipCompleted){
            this.props.history.push('/my-account/premier/member-benefits')
        }
        else{
            this.joinPremier(this.props)
        }
        let dataLayerData = {
            'event': 'join_premier',
            'title': 'Premier-BlockAd-Homepage-Unlock2'
        }
        addDataLayer(dataLayerData);
    }

    /* checks whether the input is valid or not */
    onInputValidation = (event, formName) => {
        let controlError = '';

        if (event.target.name === 'zipcode') {
            if (isNaN(Number(event.target.value)))
                event.target.value = '';
        }

        /* checks all the validators for the control */
        for (let validator of this.state[formName][event.target.name].validators) {
            controlError = validator(event.target.value);
            if (controlError) break;
        }

        /* sets the state of the control and form validity */
        this.setState({
            [formName]: {
                ...this.state[formName],
                [event.target.name]: {
                    ...this.state[formName][event.target.name],
                    value: event.target.value,
                    valid: !Boolean(controlError),
                    error: controlError
                }
            },
            errorMessage: '',
            errorMessage1: '',
        },
            () => {
                /* check form validity */
                if (controlError)
                    this.setState({ formValid: false });
                else {
                    let formValid = true;
                    for (let control of Object.keys(this.state[formName])) {
                        if (!this.state[formName][control].valid) {
                            formValid = false;
                            break;
                        }
                    }
                    this.setState({ formValid: formValid });
                }
            });
    }

    estateSaleFind = (event) => {
        event.preventDefault();
        const estateForm = this.state.estateSaleForm;
        if (!estateForm.zipcode.value) {
            this.setState({
                errorMessage: 'Please enter value'
            });
        } else {
            this.estateSaleFindNavigate(estateForm);
        }
    }

    estateSaleFindOne = (event) => {
        event.preventDefault();
        const estateForm = this.state.estateSaleForm1;
        if (!estateForm.zipcode.value) {
            this.setState({
                errorMessage1: 'Please enter value'
            });
        } else {
            this.estateSaleFindNavigate(estateForm);
        }
    }

    estateSaleFindNavigate = (estateForm) => {
        const data = {
            zipcode: estateForm.zipcode.value,
            miles: estateForm.miles.value
        };
        const final = btoa(JSON.stringify(data));
        this.props.history.push(`/estate-sale/list/${final}`);
    }

    navigateToAbout = (flag) => {
        this.props.history.push(`/about/${flag}`);
    }

    removeSale = (index) => {
        this.setState({
            refreshScreen: true
        }, () => {
            const temp = this.state.endingSoon;
            temp.splice(index, 1);
            this.setState({
                endingSoon: temp
            });
            setInterval(() => {
                this.setState({
                    refreshScreen: false
                });
            }, 500)
        });

    }

    removeTodayFeature = () => {
        this.setState({
            todayDeal: []
        });
    }

    scrollToPrevious = () => {
        this.homeRef.current.scrollTo({ top: this.state.scrollTo, left: 0 });
    }

    setScrollValue = (event) => {
        const scrollTop = event.target.scrollTop;
        this.setState({
            scrollTo: scrollTop
        });
    }

    onSlid = (event) => {
        this.setState({
            activeIndex: event
        });
    }

    navigateToPlayStore = (type) => {
        if (type == 'appstore') {
            let dataLayerData = {
                'event': 'app_store_clicks',
                'title': APP_STORE_URL
            }
            addDataLayer(dataLayerData);
            window.open(APP_STORE_URL, "_blank");
        } else if (type == 'googlestore') {
            let dataLayerData = {
                'event': 'app_store_clicks',
                'title': PLAY_STORE_URL
            }
            addDataLayer(dataLayerData);
            window.open(PLAY_STORE_URL, "_blank");
        }
    }

    moveToWorthPointUrl(url) {
        window.open(url, "_blank");
        let dataLayerData = {
            'event': 'worth_point',
            'title': url
        }
        addDataLayer(dataLayerData);
    }

    componentWillUnmount() {
        // const data = {
        //     todayDeal: this.state.todayDeal,
        //     endingSoon: this.state.endingSoon,
        //     scrollTo: this.state.scrollTo
        // };
        // convertToMaintainData(homeState, data);
        store.dispatch({ type: 'TOGGLE_SEARCH_BOX', payload: true });
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }

    render() {
        return (
            <div className="home-main" ref={this.homeRef} onScroll={this.setScrollValue}>
                <Helmet>
                    <title>CTBids | Online Estate Sale Auctions</title>
                    <meta name='description' content="Best Auction sales, sell electronics, cars, clothes, collectibles, more on CTBids, online estate marketplace. Top brands, low prices, shipping, or pick up from your nearest store." />
                    <meta name="google-site-verification" content="PPiTWW_2xWSo19mPTsAyR2w2L4blIGf5dTyAmvknUrs" />
                    <link rel="canonical" href="https://ctbids.com" />
                </Helmet>
                <h1 className='d-none'>Welcome Home to CTBids</h1>
                <h1 className='d-none'>Discover and Bid on Unique &amp; Everyday Treasures</h1>
                {
                    this.state.loading ?
                        <div className="loader">
                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/loader.gif`} className="loader-icon" alt="loader-icon"></img>
                        </div> :
                        <div>
                            <div className="content">
                                <div className="welcome-content" style={{ backgroundImage: `url(${homeBanner})` }}>
                                    <div style={{textAlign: 'center'}}>
                                    <h1 className="welcome-message animate__animated animate__fadeInDown" >Welcome <span className='italic-style'>Home</span>  to CTBids</h1>
                                    <div className="welcome-section-two animate__animated animate__fadeInUp">                                       
                                        <h3 className="bidding">When you shop CTBids, you become a part of something bigger - supporting seniors and their loved ones. Our site is made up of unique and everyday treasures, carefully curated to tell a story.</h3>
                                    </div>

                                    </div>
                                    
                                    <div className='d-flex'>
                                       

                                        <div className="bottom-right">
                                            <div className="powered-by">
                                                <img className="caring clickable" alt="Powered" src={caringtransitionslogo} onClick={this.openCaringTransitions}></img>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div style={{  justifyContent: 'center' }} className="h2 discover">
                                    <div>
                                        Discover and Bid on Unique & Everyday Treasures
                                    </div>
                                    <div style={{ display: 'flex', justifyContent:'center', marginTop: '20px' }}>
                                    <Form onSubmit={() =>this.onSearchItems('itemvalue')} style={{ marginLeft: '20px', width: '30%' }}>
                                        <div className="input-group">
                                            <Form.Control className="item-serach-input-box" type="text" aria-label='Search All Items' name="itemserach" placeholder="Search All Items" onChange={this.inputValueChange} value={this.state.searchValue.value}/>
                                            <span className="input-group-append align-items-center clickable" onClick={() => this.onSearchItems('itemvalue')}>
                                                <i className="fa fa-search"></i>
                                            </span>
                                        </div>
                                    </Form>
                                    <div className="h2 " style={{fontWeight: '600',marginLeft: '20px' }}>OR</div>
                                    
                                    <Form onSubmit={() => this.onSearchItems('zipcode')} style={{ marginLeft: '30px', width: '30%' }}>
                                        <div className="input-group">
                                            <Form.Control pattern="[0-9]{5}" className="item-serach-input-box" type="text" aria-label='Enter Zip code to search items near you' placeholder="Enter Zip Code To Search Items Near You" name="zipcode" onChange={this.inputValueChange} value={this.state.zipcode} />
                                            <span className="input-group-append align-items-center clickable" onClick={() => this.onSearchItems('zipcode')}>
                                                <i className="fa fa-search"></i>
                                            </span>
                                        </div>
                                    </Form>

                                    </div>
                                </div>

                        
                                <div className="section-two d-flex align-items-center justify-content-center">
                                    <div className="large-screen-width">
                                        <Row xs={1} sm={1} md={1} lg={3}>
                                            <Col className="section-container">
                                                <div className="find-estate-sale d-flex flex-column align-items-center justify-content-center">
                                                    <div className="h5 header">
                                                        <span className="border-set"></span>
                                                        CTBids Launches Membership Program
                                                        {/* Download Our Mobile App */}
                                                    </div>
                                                    <div className='mt-4 text-center premier-img clickable' style={{ width: "90%" }}  onClick={() => this.joinToday()}>
                                                        <img src={premiermemberAd} style={{ height: '500px', padding: "4px 16px" }} className=' w-100 image-section' alt="advertise-image" />
                                                        <div className='ctbids-app-link-image '>
                                                            <Button className='join-today'>JOIN TODAY!</Button>
                                                        </div>
                                                    </div>

                                                    {/* <div className='mt-4 text-center'>
                                                        <img src={uniquefeatureImage} style={{ height: '500px', padding: "4px 16px" }} className=' w-100 image-section' alt="advertise-image" />
                                                        <div className='ctbids-app-link-image '>
                                                            <img className="ctbids-app-image clickable" src={`${process.env.PUBLIC_URL}/static/header/appStore.png`} alt='app-store-icon' onClick={() => { this.navigateToPlayStore('appstore') }} />
                                                            <img className="ctbids-app-image mobile-top clickable" style={{ marginLeft: '10px' }} src={`${process.env.PUBLIC_URL}/static/header/googlePlay2.png`} alt='google-play-icon' onClick={() => { this.navigateToPlayStore('googlestore') }} />
                                                        </div>
                                                    </div> */}
                                                  

                                                    {/* <div className="content-conatiner">
                                                        <div className="middle">
                                                            <Form className="form" onSubmit={this.estateSaleFind}>
                                                                <Form.Group controlId="home-zipcode">
                                                                    <Form.Control type="text" aria-label='Enter zip code' placeholder="Enter Zip code" name="zipcode" value={this.state.estateSaleForm.zipcode.value} onChange={(event) => this.onInputValidation(event, "estateSaleForm")} />
                                                                    {
                                                                        this.state.estateSaleForm.zipcode.value && this.state.estateSaleForm.zipcode.error ? <small className="text-danger">{this.state.estateSaleForm.zipcode.error}</small> : null
                                                                    }
                                                                    {
                                                                        this.state.errorMessage ? <small className="text-danger">{this.state.errorMessage}</small> : null
                                                                    }
                                                                </Form.Group>
                                                                <Form.Group controlId="home-distance">
                                                                    <Form.Control as="select" placeholder="Select distance" aria-label="select distance" name="miles" value={this.state.estateSaleForm.miles.value} onChange={(event) => this.onInputValidation(event, "estateSaleForm")} >
                                                                        <option value="5">5 Miles</option>
                                                                        <option value="10">10 Miles</option>
                                                                        <option value="25">25 Miles</option>
                                                                        <option value="50">50 Miles</option>
                                                                        <option value="100">100 Miles</option>
                                                                        <option value="250">250 Miles</option>
                                                                    </Form.Control>
                                                                </Form.Group>
                                                            </Form>
                                                            <div className="button clickable" onClick={this.estateSaleFind}>
                                                                Find
                                                            </div>
                                                            <div className="browse-link clickable" onClick={this.estateSaleList}>
                                                                Browse All <i className="fa fa-chevron-right browse-link-arrow"></i>
                                                            </div>
                                                        </div>
                                                        <div className="bottom-set text-center">
                                                            <img src={homeSofa} alt="sofa-image" className="estate-sale-image"></img>
                                                        </div>
                                                    </div> */}
                                                </div>
                                            </Col>
                                            <Col className="section-container second-col">
                                                <div className="h5 header">
                                                    <span className="border-set"></span>
                                                    Today's Featured Estate Sales
                                                </div>
                                                {
                                                    this.state.featureSaleLoading ?
                                                        <div className="loader">
                                                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/loader.gif`} className="loader-icon" alt="loader-icon"></img>
                                                        </div> :
                                                        this.state.todayDeal && this.state.todayDeal.length > 0 ?
                                                            <div className="carosal-door-view">
                                                                <Carousel onSlid={this.onSlid} controls={false}>
                                                                    {
                                                                        this.state.todayDeal.map((todayDeal, index) =>
                                                                            <Carousel.Item key={`carousel_${index}`}>
                                                                                {
                                                                                    this.state.activeIndex === index ?
                                                                                        <DoorView className={`d-flex align-items-center justify-content-center`} config={{ index: index }} sale={todayDeal}{...this.props} navigate={this.navigate} removeSale={this.removeTodayFeature}></DoorView>
                                                                                        : null
                                                                                }
                                                                            </Carousel.Item>
                                                                        )
                                                                    }

                                                                </Carousel>
                                                            </div>
                                                            : <div className="no-data-found h-100 d-flex flex-column align-items-center justify-content-center">
                                                                <div className="no-sale-image">
                                                                    <img src={noSale} alt="no-sale"></img>
                                                                </div>
                                                                <div className="text-center text-muted h5">
                                                                    No sale available
                                                                </div>
                                                            </div>
                                                }
                                            </Col >
                                            { 
                                                this.state.advList?.length > 0  ?
                                                    <Col className="section-container">
                                                        {
                                                                this.state.advList.map((advdata) => (
                                                                    <div>                                                                 
                                                                        <div className="h5 header">
                                                                            <span className="border-set"></span>
                                                                            {advdata.title}
                                                                        </div>
                                                                        <div className='mt-4 text-center'>
                                                                            <img onClick={() => this.moveToUrl(advdata.seourl, advdata.title)} src={advdata.advertisedisplayurl} style={{ cursor: 'pointer',height: '500px' }} className=' w-100 p-3 image-section' alt="advertise-image" />
                                                                            <p className='mt-3' style={{ padding: "0px 20px" }}>{advdata.advertisedisplaytext}</p>
                                                                        </div>
                                                                    </div>

                                                                ))
                                                            }
                                                    </Col> :
                                                    !this.state.advListLoading ?
                                                    <Col className="section-container">
                                                        <div className="h5 header">
                                                            <span className="border-set"></span>
                                                            Sell With Us
                                                        </div>
                                                        <div className="sell-with-us">
                                                            <div className="sell-with-us-block d-flex flex-column justify-content-around">
                                                                <div className="section-one">
                                                                    <div className="two-way">
                                                                        <h2 className="text-center">2 WAYS TO SELL</h2>
                                                                    </div>
                                                                    <div className="text-center sub-text">
                                                                        Caring Transitions can assist anyone <span> needing to sell stuff!</span>
                                                                    </div>
                                                                    <div className="d-flex align-items-center justify-content-center">
                                                                        <div className="button clickable" onClick={this.sellWithUs}>
                                                                            <div className="home">
                                                                                <img src={sellWith} alt="sell-home-icon"></img>
                                                                            </div>
                                                                            <div className="word">SELL WITH US</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="section-two d-flex flex-colum align-items-center justify-content-center">
                                                                    <div className="or-container"></div>
                                                                    <div className="or-div">Or</div>
                                                                </div>
                                                                <div className="section-three">
                                                                    <div className="ban-image">
                                                                        <img src={sellWithUsBan} alt="sellWithUsBan"></img>
                                                                    </div>
                                                                    <div className="sub-text text-center">
                                                                        You can host an Estate Sale or Online Auction for others as a Caring Transitions Owner
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Col> : ''}
                                        </Row>
                                    </div>
                                </div>

                                <div className="section-two d-flex aling-items-center justify-content-center">
                                    <div className="large-screen-width">
                                        <Row xs={1} sm={1} md={1} lg={3}>
                                            <Col></Col>
                                            <Col className="section-container d-flex aling-items-center justify-content-center">
                                                <img className='clickable frchimage' src={franchise} alt="bottom-left" onClick={() => this.moveToWorthPointUrl('https://www.caringtransitionsfranchise.com/')} />
                                            </Col>
                                            <Col></Col>

                                        </Row>                    
                                    </div>
                                </div>
                               
                                {/* {
                                    this.props.user.profilecompleted === 1 ? null :
                                        <div className="profile-handle">
                                            <div className="d-md-flex align-items-center justify-content-center">
                                                <div className="info">
                                                Join a half million people who are looking for unique treasures
                                                </div>
                                                <div className="d-flex align-items-center justify-content-center">
                                                    <div className="left-side h5 clickable" onClick={() => { this.signInOpen(isAuthorized()) }}>
                                                        {isAuthorized() ? 'Complete Your Profile' : 'Sign In'}
                                                    </div>
                                                    <div className="right-side h5 clickable" onClick={() => { this.signInOpen(isAuthorized()) }}>To See Exciting Offers</div>
                                                </div>
                                            </div>
                                        </div>
                                } */}

                                <div className="d-flex align-items-center justify-content-center h2 discover">
                                    Discover What's Behind The Doors of Our Estates
                                </div>
                                <div className="home-estate-sale-list">
                                    <div className="header-content d-flex align-items-center justify-content-center">
                                        <div className="find-estate">
                                            <div className="d-lg-flex align-items-md-center justify-content-between">
                                                <div className="left d-flex align-items-center">
                                                    <div className="h5 header">
                                                        <span className="border-set"></span>
                                                        Estate Sales Ending Soon
                                                    </div>
                                                </div>
                                                <div className="right d-md-flex align-items-start">
                                                    <Form className="form d-md-flex" onSubmit={this.estateSaleFindOne}>
                                                        <Form.Group controlId="zipcode">
                                                            <Form.Control type="text" placeholder="Enter Zip code" aria-label="Enter zipcode" name="zipcode" value={this.state.estateSaleForm1.zipcode.value} onChange={(event) => this.onInputValidation(event, "estateSaleForm1")} />
                                                            {
                                                                this.state.estateSaleForm1.zipcode.value && this.state.estateSaleForm1.zipcode.error ? <small className="text-danger">{this.state.estateSaleForm1.zipcode.error}</small> : null
                                                            }
                                                            {
                                                                this.state.errorMessage1 ? <small className="text-danger">{this.state.errorMessage1}</small> : null
                                                            }
                                                        </Form.Group>
                                                        <Form.Group controlId="distance" className="select">
                                                            <Form.Control as="select" placeholder="Select distance" aria-label="Select distance" className="select__field" name="miles" value={this.state.estateSaleForm1.miles.value} onChange={(event) => this.onInputValidation(event, "estateSaleForm1")}>
                                                                <option value="5">5 Miles</option>
                                                                <option value="10">10 Miles</option>
                                                                <option value="25">25 Miles</option>
                                                                <option value="50">50 Miles</option>
                                                                <option value="100">100 Miles</option>
                                                                <option value="250">250 Miles</option>
                                                            </Form.Control>
                                                        </Form.Group>
                                                    </Form>
                                                    <Button className="find-button" onClick={this.estateSaleFindOne}>Find</Button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="content-body">
                                        <div className="d-flex align-items-center justify-content-center">
                                            <Row xs={1} sm={1} md={1} lg={this.state.endingSoon.length < 3 ? this.state.endingSoon.length : this.state.innerWidth < 1225 ? 2 : this.state.innerWidth >= 1707 ? 3 : 3} className='sale-card-wrapper'>
                                                {
                                                    this.state.endingSoon.map((items, endingSoonIndex) => {
                                                        return (
                                                            <Col key={`items_${endingSoonIndex}_${items.id}`}>
                                                                {
                                                                    this.state.refreshScreen ? null :
                                                                        <DoorView sale={items} config={{ index: endingSoonIndex }} navigate={this.navigate} removeSale={() => this.removeSale(endingSoonIndex)}></DoorView>
                                                                }
                                                            </Col>
                                                        )
                                                    })
                                                }
                                            </Row>
                                            {
                                                this.state.endingSoon.length === 0 ?
                                                    <div className="no-data-found h-100 d-flex flex-column align-items-center justify-content-center">
                                                        <div className="no-sale-image">
                                                            <img src={noSale} alt="no-sale"></img>
                                                        </div>
                                                        <div className="text-center text-muted h5">
                                                            No sale available
                                                        </div>
                                                    </div> : null
                                            }
                                        </div>
                                        {
                                            this.state.endingSoon.length === 3 ?
                                                <div className="d-flex justify-content-center">
                                                    <div className="browse-all clickable mobile-ads" onClick={this.estateSaleList}>
                                                        Browse all
                                                    </div>
                                                </div> : null
                                        }
                                    </div>
                                </div>
                                {
                                    ADSENSE.ENABLE ? <Adsense googleAdCenter slotId={ADSENSE.HOME.slotId} /> : ''
                                }
                                <div className="d-flex align-items-center justify-content-center h2 discover">
                                      Bidding Starts at $1
                                </div>
                                <div className={`popular d-flex align-items-center justify-content-center ${this.state.viewMoreItems.mostPopular && this.state.viewMoreItems.mostPopular.length === 0 ? '' : ''}`}>
                                    <div className="large-screen-width">
                                        <div className="h5 header">
                                            <span className="border-set"></span>
                                            Most Popular
                                        </div>
                                        <SaleCardViewDataTable className="px-12" modalWithContainer config={{ postData: this.state.popular}}{...this.props} getItemsList={event => { this.getItemsList(event, 'most-popular') }} addBidCount></SaleCardViewDataTable>
                                                                                
                                        <div className="d-flex justify-content-center">
                                            <div className="browse-all clickable" onClick={() => { this.viewMoreItems('most-popular') }}>
                                                More
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={`unique d-flex align-items-center justify-content-center ${this.state.viewMoreItems.coolAndUnique && this.state.viewMoreItems.coolAndUnique.length === 0 ? '' : ''}`}>
                                    <div className="large-screen-width">
                                        <div className="h5 header">
                                            <span className="border-set"></span>
                                            Cool &amp; Unique Treasures
                                        </div>
                                        <SaleCardViewDataTable className="px-12" modalWithContainer config={{ postData: this.state.unique }}{...this.props} getItemsList={event => { this.getItemsList(event, 'cool-and-unique') }}></SaleCardViewDataTable>
                                        <div className="d-flex justify-content-center">
                                            <div className="browse-all clickable" onClick={() => { this.viewMoreItems('cool-and-unique') }}>
                                                More
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {!this.props.user.membershipCompleted ?
                                    <div className='w-100' style={{ justifyContent: 'center', alignItems:' center', display: 'flex',  }}>
                                        {bannerImage(this.props, 'Premier-BannerAd-Homepage-Unlock3')}
                                    </div> : ''}
                               <div style={{ marginBottom: '3%' }}>
                                    <img className="w-100" alt="you make diffrence " src={youmakediffrence}></img>
                               </div>
                            </div>
                            <Footer className={'remove-bottom'}{...this.props} />
                        </div>
                }
            </div>
        );
    }
}

export default connect(state => state)(Home);
